/**
 * Minimal cookie helpers. No cookie util existed before; keep this dependency-free
 * and defensive — cookie access can throw in privacy-restricted contexts, and every
 * caller must survive that (see src/helpers/attribution.ts).
 */

type CookieOptions = {
  /** e.g. '.respona.com' to share across subdomains */
  domain?: string;
  /** lifetime in days; omit for a session cookie */
  days?: number;
  path?: string;
};

export const getCookie = (name: string): string | null => {
  try {
    const prefix = `${encodeURIComponent(name)}=`;
    const found = document.cookie.split('; ').find((row) => row.startsWith(prefix));
    return found ? decodeURIComponent(found.substring(prefix.length)) : null;
  } catch {
    return null;
  }
};

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  try {
    const { domain, days, path = '/' } = options;
    let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=${path}; SameSite=Lax`;
    if (domain) cookie += `; domain=${domain}`;
    if (days !== undefined) {
      const expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000);
      cookie += `; expires=${expires.toUTCString()}`;
    }
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  } catch {
    // Cookie writes are best-effort; callers must not depend on success.
  }
};
